// extracted by mini-css-extract-plugin
export default {"btnpwd":"_21ad10b347"};